var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_303_403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.75 0.0126953H6.25C2.79875 0.0126953 0 2.81145 0 6.2627V23.7627C0 27.2139 2.79875 30.0127 6.25 30.0127H23.75C27.2025 30.0127 30 27.2139 30 23.7627V6.2627C30 2.81145 27.2025 0.0126953 23.75 0.0126953ZM10 23.7627H6.25V10.0127H10V23.7627ZM8.125 8.4277C6.9175 8.4277 5.9375 7.4402 5.9375 6.2227C5.9375 5.0052 6.9175 4.0177 8.125 4.0177C9.3325 4.0177 10.3125 5.0052 10.3125 6.2227C10.3125 7.4402 9.33375 8.4277 8.125 8.4277ZM25 23.7627H21.25V16.7577C21.25 12.5477 16.25 12.8664 16.25 16.7577V23.7627H12.5V10.0127H16.25V12.2189C17.995 8.98645 25 8.7477 25 15.3139V23.7627Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_303_403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.0126953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.ad45cc9f7fbe64db3d624861be0a986f.svg";
export { ForwardRef as ReactComponent };